import {AbstractControl} from '@angular/forms';
export class CustomValidators {

    static MatchPassword(AC: AbstractControl) {
       const password = AC.get('password').value; // to get value in input tag
       const confirmPassword = AC.get('password_confirmation').value; // to get value in input tag
        if (password !== confirmPassword) {
            AC.get('password_confirmation').setErrors( {MatchPassword: true});
        } else {
            return null;
        }
    }

    static validateEmailAddress(AC: AbstractControl) {
        const emailAddress = AC.value;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(emailAddress)) {
            return null;
        }
        return { 'emailAddress': true };
    }
    static validateTextField(AC: AbstractControl) {
        const string = AC.value;
        if (string != null && string.trim().length !== 0) {
            return null;
        }
        return { 'textField': true };
    }

    static validateTextFieldLength(min: number, max: number) {
        return (control: AbstractControl) => {
            const string = control.value;
            if (string != null && string.trim().length >= min && string.trim().length <= max) {
                return null;
            }
            return { 'textField': true };
        };
    }

    static isAlphanumeric(AC: AbstractControl) {
            const string = AC.value;
            if ( /[^a-zA-Z0-9]/.test( string ) ) {
                return { 'textField': true };
            }
            return null;
    }

    static username(AC: AbstractControl) {
        const string = AC.value;
        if ( /[^a-zA-Z0-9 ]/.test( string ) ) {
            return { 'textField': true };
        }
        return null;
}
}
